import { type ComponentsOverrides, type Theme } from '@mui/material/styles'

export const overridesCheckbox = (theme: Theme): ComponentsOverrides['MuiCheckbox'] => ({
  root: {
    color: theme.customPalette.onElements.outline,
    margin: `-${theme.spacing(1)}`,
    padding: theme.spacing(1),
  },
})
